<script>
export default {
  props: {
    defaultload: {
      type: Function,
    },
  },
  data() {
    return {
      lang: this.$i18n.locale == "en" ? "English" : "中文",
    };
  },
  methods: {
    clickEnglish() {
      this.GLOBAL.dispatchEvent("languageChanged", "en");
      this.lang = "English";
    },
    clickChinese() {
      this.GLOBAL.dispatchEvent("languageChanged", "zh");
      this.lang = "中文";
    },
    // setLocale(locale) {
    //   this.GLOBAL.dispatchEvent("languageChanged", locale);
    //   this.$i18n.locale = locale
    //   this.lang = locale == 'en' ? 'English' : 'Chinese';
    //   localStorage.lang = locale;
    //   if (this.defaultload) {
    //     this.defaultload();
    //   }
    // }
    setLocale(locale) {
      this.GLOBAL.dispatchEvent("languageChanged", locale);
      this.$i18n.locale = locale;
      this.lang = locale === "en" ? "English" : "中文";
      localStorage.setItem("dpLang", locale);
    },
  },
  mounted: function () {
    let lang = this.$i18n.locale;
    if (localStorage.getItem("dpLang")) {
      lang = localStorage.getItem("dpLang");
    }
    this.setLocale(lang);
  },
  // mounted() {
  //   //this.GLOBAL.dispatchEvent('languageChanged', 'en');
  //   if (localStorage.lang == 'zh') {
  //     setTimeout(() => {
  //       this.setLocale('zh');
  //     }, 1000);
  //   }
  //   this.GLOBAL.dispatchEvent("languageChanged", localStorage.lang);
  // }
};
</script>
<template>
  <div class="d-inline-block w-100">
    <div
      :class="$style.languageBlock"
      class="flex-row d-flex align-items-center justify-content-between"
    >
      <span :class="$style.title">{{lang === 'English'? 'Language' : '语言'}}</span>

      <div>
        <b-dropdown :text="lang" class="simple-dropdown">
          <b-dropdown-item v-on:click="setLocale('en')"
            >English</b-dropdown-item
          >
          <b-dropdown-item v-on:click="setLocale('zh')"
            >中文</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";
.languageBlock {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 20px;
  .title {
    color: $white;
    font-family: $family-bold;
  }
}
</style>
